import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ReflectionInfoFragment = { id: string, pk: number, name: string, shortName: string, slug: string, videoUrl: string | null };

export const ReflectionInfoFragmentDoc = gql`
    fragment ReflectionInfoFragment on ProductSiteSpecificsType {
  id
  pk
  name
  shortName
  slug
  videoUrl
}
    `;